module.exports = __webpack_public_path__ + "static/media/CLIDE SURVEY GRAPH.873c2fd5.gif";